import axios from 'axios';
import config from '../helpers/configProvider';

export default () => {
  return axios.create({
    baseURL: config.getEnv(config.enum.VUE_APP_AUTH_SERVICE_URL) || `http://localhost:8081`,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  });
};
